import { CompanyPagination } from '../model/company_pagination';
import { FetchPublicCompanyRepository } from '../../data/repository/fetch_public_company_repository';
import { Pagination } from "@/core/domain/model/pagination";
import { DataOptions } from "vuetify";
import { en } from '../model/company';

export interface FetchPublicCompanyUseCase {
    (pagination: DataOptions, search: string): Promise<CompanyPagination>
}

const fetchPublicCompanyUseCase = (repository: FetchPublicCompanyRepository): FetchPublicCompanyUseCase => async (pagination: DataOptions, search: string) => {
    try {
        const payload: Pagination = {
            sort: pagination.sortBy.map((s: string) => en[s]).join(','),
            descending: pagination.sortDesc.join(','),
            page: pagination.page,
            itemsPerPage: pagination.itemsPerPage,
            search: search
        }
        return await repository(payload);
    } catch (error) {
        throw error
    }
}

export default fetchPublicCompanyUseCase;